module.exports = __webpack_public_path__ + "media/images/default/pages/about/doctor-1-2545c02006689b6308d4cab5018eee40.jpg";